export default function AgencyController(
  $q,
  $rootScope,
  $scope,
  addAuditAgencyDialog,
  alerts,
  amSharedModelService,
  deleteAgencyConfirmDialog,
  loaderService,
  ssDialogService,
  userService
) {
  const vm = this;

  // Set Default Values
  vm.agency.isSelected = (vm.agency.agencyId === vm.audit.agencyId);
  vm.enabled = ((vm.agency.isSelected) || (vm.audit.agencyId) || (vm.audit.agencyId === 0));
  vm.canEdit = userService.getUserPermission('displayAMAddLink');
  vm.canDelete = userService.getUserPermission('displayAMDeleteLink');

  // Attach Event Handlers
  vm.handleNameClick = handleNameClick;
  vm.handleSelectAgencyChange = handleSelectAgencyChange;
  vm.handleEditAgency = handleEditAgency;
  vm.handleDeleteAgency = handleDeleteAgency;

  _initEventListeners();

  /** *********************************************
   * Event Handlers
   */

  function handleEditAgency($event) {
    _showAddAuditAgencyDialog($event);
  }

  function handleDeleteAgency($event) {
    _showDeleteAgencyConfirmDialog($event);
  }

  function handleSelectAgencyChange() {
    if (vm.isEdit) {
      _sendChangeEvent();
    }
  }

  function handleNameClick() {
    if (vm.isEdit) {
      vm.agency.isSelected = !vm.agency.isSelected;
      _sendChangeEvent();
    }
  }

  /** *********************************************
   * Private Functions
   */

  function _initEventListeners() {
    $scope.$on('selectAMAgency', (event, opt) => {
      if (opt.agency.agencyId !== vm.agency.agencyId) { _disableSelection(); }
    });
    $scope.$on('deselectAMAgency', (event, opt) => {
      if (opt.agency.agencyId !== vm.agency.agencyId) { _enableSelection(); }
    });
  }

  function _showAddAuditAgencyDialog($event) {
    ssDialogService.dialogs.auditTrail.addAuditAgencyDialog = ssDialogService.alert(
      addAuditAgencyDialog.getOptions($event, {
        customerId: vm.customerId,
        audit: vm.audit,
        agency: vm.agency,
        agencies: vm.agencies,
        auditTypes: vm.auditTypes,
        coordinators: vm.coordinators,
        dataTypes: vm.objectDataTypes,
        refreshAudit: false,
        updateCallback: _handleUpdatedAgency,
      })
    );
    return ssDialogService.show(ssDialogService.dialogs.auditTrail.addAuditAgencyDialog);
  }

  function _showDeleteAgencyConfirmDialog($event) {
    ssDialogService.dialogs.auditTrail.deleteAgencyConfirmDialog = ssDialogService.alert(
      deleteAgencyConfirmDialog.getOptions($event, {
        customerId: vm.customerId,
        audit: vm.audit,
        agency: vm.agency,
        agencies: vm.agencies,
        auditTypes: vm.auditTypes,
        coordinators: vm.coordinators,
        dataTypes: vm.dataTypes,
        refreshAudit: false,
      })
    );
    return ssDialogService.show(ssDialogService.dialogs.auditTrail.deleteAgencyConfirmDialog);
  }

  function _handleUpdatedAgency(agency) {
    $rootScope.$broadcast('selectAMAgency', { agency }); // legacy
    $rootScope.$broadcast('updateAMAgency', { agency });
    $rootScope.$broadcast('refreshAMAgencies', { agency }); // legacy
  }

  function _enableSelection() {
    vm.enabled = true;
  }

  function _disableSelection() {
    vm.enabled = false;
  }

  function _sendChangeEvent() {
    if (vm.agency.isSelected) {
      $rootScope.$broadcast('selectAMAgency', { agency: vm.agency });
    } else {
      $rootScope.$broadcast('deselectAMAgency', { agency: vm.agency });
    }
  }
}

AgencyController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'addAuditAgencyDialog',
  'alerts',
  'amSharedModelService',
  'deleteAgencyConfirmDialog',
  'loaderService',
  'ssDialogService',
  'userService'
];
